// Copy for the "Iniciar cobro" flow, keyed by the error name the API sends
// (POST /payments/payin/channel, REC-1400). Never the API message on a 5xx.

const BY_NAME = {
  ChannelPayinOriginMissing:
    'Esta diligencia no viene de una solicitud del canal.',
  QuoteNotAccepted: 'El receptor todavía no acepta la cotización.',
  QuoteRejected: 'El receptor rechazó la cotización.',
  QuoteExpired: 'La cotización venció.',
  BillingProfileNotConfigured:
    'La organización del solicitante no tiene perfil de facturación. Hay que sembrarlo antes de cobrar.',
  InvalidAmount: 'El monto de la cotización no es válido.',
  QuoteNotFound: 'No encontramos la cotización. Recarga el pedido.',
  LivePaymentAttemptExists:
    'Ya hay un intento de pago en curso para esta diligencia (otra oferta tiene el carril).',
  OfferChangedDuringCheckout:
    'La oferta cambió, recarga y vuelve a iniciar el cobro.',
  StageTransitionRejected:
    'La diligencia no está en un estado que permita cobrar.',
  CheckoutSessionInProgress:
    'Se está creando la sesión de pago. Reintenta en un minuto.',
  CheckoutSessionPaymentClosed:
    'El intento de pago ya está cerrado. Recarga el pedido.',
  CheckoutSessionInvoiceMissing:
    'La sesión de pago no tiene factura asociada. Avisa al equipo dev.',
  InvalidQuotedAmount: 'El monto cotizado no es válido.',
  PaymentNotFound: 'No encontramos el pago. Recarga el pedido.',
  CheckoutSessionConflictUnresolved:
    'La sesión de pago quedó en conflicto. Avisa al equipo dev.',
};

export const PAID_ERROR = 'QuoteAlreadyPaid';

export const FORBIDDEN_TEXT =
  'Tu usuario no tiene el permiso para iniciar el cobro.';
const TITLE = 'No se pudo iniciar el cobro';
const NEUTRAL = 'Intenta de nuevo en un momento.';

// `{ paid: true }` is not a failure: the quote is already settled and the panel
// shows "Pagado". Otherwise `{ title, message }` for the toast.
export function payinFailure(error, name) {
  if (name === PAID_ERROR) return { paid: true };
  if (BY_NAME[name]) return { title: TITLE, message: BY_NAME[name] };
  if (error?.status === 403) return { title: TITLE, message: FORBIDDEN_TEXT };
  const status = error?.status;
  const is5xx = typeof status !== 'number' || status >= 500;
  return {
    title: TITLE,
    message: is5xx ? NEUTRAL : (error?.message ?? NEUTRAL),
  };
}

// Secondary data only: Toku's state when the session was created, never
// refreshed. It does not say whether the charge is paid or the session valid.
export const CHECKOUT_STATE_LABEL = {
  OPEN: 'abierta',
  COMPLETED: 'completada',
};
